// Toast system
export enum ToastType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}
export type ToastMessage = {
  id?: string;
  message: string;
  type: ToastType;
  timeout: number;
}
export type ShowToast = (message: string, type?: ToastType, timeout?: number) => void;
